export const FILTERS_ID_SEPARATOR = '::';
export const FILTER_PRICE_KEY = 'priceRange';
export const FILTER_LOCALE_KEY = 'locale';
export const FILTER_CATALOG_KEY = 'catalog';
